import { GetSchedulesByExperienceIdResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { scheduleKeys } from "../queryKeys";

const getExperienceSchedules = async (experienceId: string) => {
  const resp = await api.get<GetSchedulesByExperienceIdResponseBodyType>(
    `/v2/schedules/experiences/${experienceId}`
  );
  return resp.data;
};

export const useGetExperienceSchedules = (experienceId: string | undefined) => {
  return useQuery<GetSchedulesByExperienceIdResponseBodyType, Error>({
    queryKey: scheduleKeys.one(experienceId!),
    queryFn: async () => getExperienceSchedules(experienceId!),
    enabled: !!experienceId,
  });
};
